import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const CategoryOne = () => {
  const swiperRef = useRef(null);

  const categories = [
    {
      id: 1,
      title: "Home Printer",
      imgSrc: "/assets/img/category/home-printer.jpg",
    },
    {
      id: 2,
      title: "Office Printer",
      imgSrc: "/assets/img/category/office-printer.jpg",
    },
    {
      id: 3,
      title: "Laser Printer",
      imgSrc: "/assets/img/category/laser-printer.jpg",
    },
    {
      id: 4,
      title: "Ink, Toner & Paper",
      imgSrc: "/assets/img/category/office-printer.jpg",
    },
    {
      id: 5,
      title: "Inkjet Printer",
      imgSrc: "/assets/img/category/inkjet-printer.jpg",
    },
  ];

  useEffect(() => {
    if (!swiperRef.current) return;

    const swiperInstance = swiperRef.current.swiper;

    if (swiperInstance && swiperInstance.autoplay) {
      swiperInstance.autoplay.start();
    }

    if (swiperInstance.pagination) {
      swiperInstance.pagination.renderBullet = function (index, className) {
        let formattedNumber = index + 1 < 10 ? "0" + (index + 1) : index + 1;
        return `<span class="${className} number">${formattedNumber}</span>`;
      };
      swiperInstance.pagination.init();
      swiperInstance.pagination.update();
    }

    const multiplier = {
      translate: 0.1,
      rotate: 0.01,
    };

    const calculateWheel = () => {
      const slides = document.querySelectorAll(".single");
      slides.forEach((slide) => {
        const rect = slide.getBoundingClientRect();
        const r = window.innerWidth * 0.5 - (rect.x + rect.width * 0.5);
        let ty =
          Math.abs(r) * multiplier.translate -
          rect.width * multiplier.translate;

        if (ty < 0) {
          ty = 0;
        }
        const transformOrigin = r < 0 ? "left top" : "right top";
        slide.style.transform = `translate(0, ${ty}px) rotate(${
          -r * multiplier.rotate
        }deg)`;
        slide.style.transformOrigin = transformOrigin;
      });
    };

    const raf = () => {
      requestAnimationFrame(raf);
      calculateWheel();
    };

    raf();

    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <section className="category-area bg-top-center">
      <div className="container th-container">
        <div className="title-area text-center">
          <span className="sub-title">Shop by Category</span>
          <h2 className="sec-title">Printer Essentials</h2>
        </div>

        <Swiper
          ref={swiperRef}
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          breakpoints={{
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 3 },
            1400: { slidesPerView: 5 },
          }}
          spaceBetween={40}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          speed={1000}
          pagination={{
            clickable: true,
            el: ".swiper-pagination",
            type: "bullets",
          }}
          className="th-slider has-shadow categorySlider"
        >
          {categories.map((category) => (
            <SwiperSlide key={category.id}>
              <div className="category-card single">
                <div className="box-img global-img">
                  <img
                    src={category.imgSrc}
                    alt={category.title}
                    loading="lazy"
                  />
                </div>
                <h3 className="box-title">
                  <Link to="/shop">{category.title}</Link>
                </h3>
                <Link className="line-btn" to="/shop">
                  View Products
                </Link>
              </div>
            </SwiperSlide>
          ))}

          <div className="slider-controller w-100 justify-content-center">
            <div
              className="swiper-pagination"
              style={{ maxWidth: "100%" }}
            ></div>
          </div>
        </Swiper>
      </div>
    </section>
  );
};

export default CategoryOne;
